// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundryPage_container__inpPR","text":"ErrorBoundryPage_text__TL2To","tryAgainButton":"ErrorBoundryPage_tryAgainButton__B9vOv"};